import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {ConstitutiveActServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormFramework from './InnerFormDocsAct';
import {FieldShape} from 'commons/shapes';
import {formValidator, isFutureDate} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

DocsActForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
        .isRequired,
    constituviveAct: PropTypes.any
};

const FormControl = withFormik<
    InferPropTypes<typeof DocsActForm.propTypes>,
    ConstitutiveActServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            deedFolioNumber: '',
            constitutionDate: '',
            notaryOfficeNumber: '',
        };
    },
    mapPropsToValues: (prop) => {
        const {constituviveAct} = prop;
        if (constituviveAct) {
            return {
                expedientId: constituviveAct.expedientId || 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                deedFolioNumber: constituviveAct.deedFolioNumber || '',
                protocolizationDate: constituviveAct.protocolizationDate || null,
                notaryOfficeNumber: constituviveAct.notaryOfficeNumber || '',
                file: constituviveAct.file || '',
                constitutionDate: constituviveAct.constitutionDate || '',
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                deedFolioNumber: '',
                protocolizationDate: null,
                notaryOfficeNumber: '',
                file: '',
                constitutionDate: '',
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: ConstitutiveActServiceRequest, props) => {
        const errors: FormikErrors<ConstitutiveActServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!values.file) {
            errors.file = Messages.FILE_NOT_SELECTED;
        }
        if(values.protocolizationDate){
            if(isFutureDate(values.protocolizationDate)){
                errors.protocolizationDate = Messages.INVALID_FUTURE_DATE;
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormFramework);

function DocsActForm(props: InferPropTypes<typeof DocsActForm.propTypes>) {
    const {submitHandler, fields, constituviveAct} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            submitHandler={submitHandler}
            constituviveAct={constituviveAct}
        />
    );
}

export default DocsActForm;
